import { useEffect } from 'react';

/**
 * Sets `document.title` to `speculo.ai | ${title}` while the component is
 * mounted, and restores the previous title on unmount. Use this in any
 * page-level component that wants to drive the browser tab title.
 *
 * - Pass a falsy value to leave the existing title untouched (useful while
 *   data is loading).
 * - Components further down the tree can override the title their parent
 *   set — restoration on unmount makes nested overrides safe.
 *
 * Canonical example (parent route sets default, child swaps in dynamic data):
 *   PageLayout — useDocumentTitle('Edit Contact')
 *   ContactEditContent — useDocumentTitle(`${firstName} ${lastName}`)
 */
export function useDocumentTitle(title: string | null | undefined): void {
  useEffect(() => {
    if (!title) return;
    const previous = document.title;
    document.title = `speculo.ai | ${title}`;
    return () => {
      document.title = previous;
    };
  }, [title]);
}
